import gsap from 'gsap'
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText);

function initManifest(){
    let lines = new SplitText(".manifest__text", { 
        type: "lines", 
        linesClass: "lineChild" ,
        // lineThreshold: 1
    });
    
    lines.lines.forEach((line, i) => {
        let spanWrap = document.createElement('span');
        spanWrap.classList.add('spanwrap')
        spanWrap.append(...line.childNodes);
        let copy = spanWrap.cloneNode(true)
        copy.classList.add('spancopy')
        line.append(spanWrap);
        line.append(copy);
        let mask = document.createElement("div");
        mask.classList.add("mask");
        // mask.append(...line.childNodes)
        line.setAttribute("data-scroll", true);
        line.setAttribute("data-scroll-offset", "20%");
        line.setAttribute("data-scroll-position", "top");
        line.setAttribute("data-scroll-class", "manifestLine");
        spanWrap.appendChild(mask);
    })
    console.log(lines.lines,'lines')
    
    
    window.locoScroll.on('scroll', (args) => {
        if(typeof args.currentElements['particle-ingredients'] === 'object') {
          let progress = args.currentElements['particle-ingredients'].progress;
        //   this.dive = progress;
        //   console.log(progress,'---OF INGREDIENTS');
          // if(this.mixer) this.currentProgress = progress;
      }
    
      var wh = window.innerHeight
      let scrollTop = args.scroll.y;
    
      for (var i = 0; i < Object.keys(args.currentElements).length; i++) {
        var c = Object.keys(args.currentElements)[i];
        if (args.currentElements[c].el && args.currentElements[c].el.classList.contains("manifestLine")) {
            var mask = args.currentElements[c].el.querySelector(".spancopy");
            if (mask) {
                let topBound = args.currentElements[c].top;
                let elHeight = args.currentElements[c].el.offsetHeight;
                let h = scrollTop + wh - topBound - elHeight;
                let w = Math.round(4 * h / ((wh + elHeight) / 100));
                gsap.to(mask, {
                    duration: .25,
                    "--clip": 1.05*Math.min(100, Math.max(0, w)) +  "%",
                    force3D: 1,
                    ease: 'ease.none'
                })
            }
        }
    
      }
      });
}


if(document.querySelector('.manifest')){
    initManifest()
}
